import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<ol class=\"breadcrumb page-breadcrumb\"><li class=\"breadcrumb-item\"><a href=\"javascript:void(0);\">SmartAdmin</a></li><li class=\"breadcrumb-item\">Category</li><li class=\"breadcrumb-item\">Sub-category</li><li class=\"breadcrumb-item active\">Page Title</li><li class=\"position-absolute pos-top pos-right d-none d-sm-block\"><span class=\"js-get-date\"></span></li></ol><div class=\"subheader\"><h1 class=\"subheader-title\"><i class=\"subheader-icon fal fa-globe\"></i> toaster <span class=\"fw-300\">サンプル</span><sup class=\"badge badge-primary fw-500\">STICKER</sup><small> Insert page description or punch line </small></h1><div class=\"subheader-block\">Right Subheader Block</div></div><div class=\"alert alert-primary\"><div class=\"d-flex flex-start w-100\"><div class=\"mr-2 hidden-md-down\"><span class=\"icon-stack icon-stack-lg\"><i class=\"base base-6 icon-stack-3x opacity-100 color-primary-500\"></i><i class=\"base base-10 icon-stack-2x opacity-100 color-primary-300 fa-flip-vertical\"></i><i class=\"ni ni-blog-read icon-stack-1x opacity-100 color-white\"></i></span></div><div class=\"d-flex flex-fill\"><div class=\"flex-fill\"><span class=\"h5\">注意事項!</span><p>特に注意事項はないです</p><p class=\"m-0\"> Follow a slogal with a useful link or call to action <a href=\"#\" target=\"_blank\">Call to action &gt;&gt;</a></p></div></div></div></div>", 3)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = {
  id: "panel-x",
  class: "panel"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"panel-hdr\"><h2>button</h2><div class=\"panel-toolbar\"><button class=\"btn btn-panel waves-effect waves-themed\" data-action=\"panel-collapse\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Collapse\"></button><button class=\"btn btn-panel waves-effect waves-themed\" data-action=\"panel-fullscreen\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Fullscreen\"></button><button class=\"btn btn-panel waves-effect waves-themed\" data-action=\"panel-close\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Close\"></button></div></div>", 1)
const _hoisted_9 = { class: "panel-container show" }
const _hoisted_10 = { class: "panel-content" }
const _hoisted_11 = { class: "frame-wrap" }
const _hoisted_12 = { class: "demo" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "panel-tag" }, " 4種類の通知を用意しているので、必要に応じて使い分ける。 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showNotification())),
                    type: "button",
                    class: "btn btn-primary waves-effect waves-themed"
                  }, " notifications表示 "),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showNotification2())),
                    type: "button",
                    class: "btn btn-primary waves-effect waves-themed"
                  }, " 全通知表示 ")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}